import { Outlet } from 'react-router-dom';
import { ClubFiltersProvider } from '@/context/ClubFiltersContext';
import { Sidebar } from '@/components/Layout/Sidebar';
import styles from '@/components/Layout/DirectoryLayout.module.css';

export function DirectoryLayout() {
  return (
    <ClubFiltersProvider>
      <div className={styles.layout}>
        <Sidebar />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </ClubFiltersProvider>
  );
}
